<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/X4ZtXy/tc-custom/9781683352600.jpg?1726574088950" alt="This image is the cover for the book Sisters Grimm: Council of Mirrors, The Sisters Grimm"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sisters Grimm: Council of Mirrors, The Sisters Grimm
      </h1>
      <p class="bookDescription body article font2">
        <p>Grany Relda’s body has been hijacked by the Master, and it’s up to Sabrina, Daphne, and the rest of the Grimms to fight for her freedom and that of Ferryport Landing in the series’s grand finale. As war rips the town apart, Sabrina consults a team of magic mirrors, who prophesize that the only way the good guys will win is if she leads the army herself. Now, Sabrina controls the fate of all the Everafters, the very people who have made her life so difficult since she and Daphne arrived in Ferryport Landing. Will they listen to a Grimm? And can she really save them? Repackaged in paperback with new cover art, these anniversary editions of the beloved Sisters Grimm series are the perfect opportunity for existing fans to revisit the adventures of the Grimm family and for new readers to discover the magic of the series for the first time.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Buckley
      </h2>
      
      <p class="authorDescription body article">Michael Buckley’s previous books include a New York Times bestseller, a Kirkus Best Fantasy Book, and two Oppenheim Toy Portfolio Platinum winners. He has written and developed television shows for several networks. He lives in Brooklyn. Peter Ferguson is a comic book and editorial artist living in Montreal.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Amulet Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?058c6bc4